// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__D_ypn","octocat":"styles_octocat__86EiB","light-bottom":"styles_light-bottom__e1_PM","light-top":"styles_light-top__68J3w"};